<template>
  <g v-if="calendar.role === 'timeDay'" :id="calendar.id" class="calendar__day-disc">
    <path fill="#FFFFFF" d="M104.5098,110.2519c0,17.9253-14.5314,32.4567-32.4567,32.4567s-32.4567-14.5314-32.4567-32.4567
		s14.5314-32.4567,32.4567-32.4567S104.5098,92.3266,104.5098,110.2519z M72.0531,85.4489
		c-13.6984,0-24.8031,11.1047-24.8031,24.8031s11.1047,24.8031,24.8031,24.8031s24.8031-11.1047,24.8031-24.8031
		S85.7514,85.4489,72.0531,85.4489z"/>
    <g>
      <g>
        <path fill="#231F20" d="M98.3767,109.0465v-0.3027c0.2539-0.208,0.5215-0.3125,0.8018-0.3125s0.5186,0.0957,0.7139,0.2871
				s0.293,0.4238,0.293,0.7002c0,0.5459-0.4219,1.2988-1.2646,2.2588h1.5996v0.2363h-2.1836
				c1.0615-1.0225,1.5928-1.8525,1.5928-2.4902c0-0.2119-0.0742-0.3896-0.2217-0.5342s-0.3311-0.2168-0.5488-0.2168
				c-0.1445,0-0.2744,0.0293-0.3887,0.0889C98.655,108.8199,98.5242,108.9156,98.3767,109.0465z"/>
        <path fill="#231F20" d="M101.4675,110.1246c-0.3008-0.2031-0.4502-0.4619-0.4502-0.7754c0-0.2471,0.0898-0.4629,0.2705-0.6445
				c0.1807-0.1826,0.3926-0.2734,0.6367-0.2734c0.251,0,0.4668,0.0898,0.6475,0.2695s0.2705,0.3945,0.2705,0.6436
				c0,0.3232-0.1455,0.583-0.4375,0.7803c0.3379,0.2031,0.5068,0.4873,0.5068,0.8516c0,0.2754-0.0938,0.5078-0.2822,0.6973
				c-0.1875,0.1895-0.418,0.2842-0.6895,0.2842c-0.2764,0-0.5098-0.0928-0.7002-0.2803c-0.1914-0.1865-0.2871-0.4141-0.2871-0.6816
				C100.9529,110.6217,101.1247,110.3317,101.4675,110.1246z M102.656,110.9615c0-0.1953-0.0713-0.3623-0.2129-0.5
				s-0.3145-0.2061-0.5186-0.2061c-0.1982,0-0.3672,0.0713-0.5068,0.2148c-0.1387,0.1436-0.209,0.3154-0.209,0.5156
				c0,0.2021,0.0703,0.374,0.2119,0.5166c0.1406,0.1426,0.3145,0.2139,0.5195,0.2139c0.208,0,0.3789-0.0713,0.5137-0.2139
				S102.656,111.1793,102.656,110.9615z M101.2751,109.3444c0,0.1875,0.0635,0.3457,0.1904,0.4746
				c0.1279,0.1299,0.2842,0.1953,0.4697,0.1953c0.1865,0,0.3418-0.0654,0.4648-0.1953c0.123-0.1289,0.1846-0.292,0.1846-0.4863
				c0-0.1826-0.0645-0.3379-0.1924-0.4668s-0.2832-0.1934-0.4678-0.1934c-0.1797,0-0.333,0.0654-0.46,0.1963
				C101.3386,108.9986,101.2751,109.1578,101.2751,109.3444z"/>
      </g>
      <g>
        <path fill="#231F20" d="M97.5964,103.7716l-0.0625-0.2959c0.207-0.2549,0.4492-0.4111,0.7227-0.4678
				c0.2754-0.0566,0.5273-0.0107,0.7578,0.1377c0.2285,0.1479,0.3711,0.356,0.4277,0.6274
				c0.1094,0.5342-0.1504,1.3564-0.7852,2.4663l1.5684-0.3218l0.0469,0.2314l-2.1387,0.4395
				c0.834-1.2148,1.1875-2.1353,1.0586-2.7593c-0.043-0.208-0.1504-0.3667-0.3242-0.4785c-0.1738-0.1123-0.3672-0.1465-0.582-0.1025
				c-0.1406,0.0293-0.2617,0.0845-0.3633,0.165C97.823,103.4943,97.7136,103.6144,97.5964,103.7716z"/>
        <path fill="#231F20" d="M101.1394,106.0157l-0.1738-0.1523c0.6309-0.687,0.9375-1.3291,0.9199-1.9248
				c-0.2266,0.2217-0.457,0.3574-0.6875,0.4053c-0.2656,0.0542-0.5059,0.0112-0.7227-0.1299
				c-0.2168-0.1396-0.3516-0.3398-0.4043-0.6016c-0.0566-0.2725-0.0156-0.5151,0.127-0.7275
				c0.1406-0.2134,0.3496-0.3477,0.627-0.4043c0.3203-0.0659,0.5938-0.0127,0.8223,0.1602c0.2305,0.1719,0.3809,0.4409,0.457,0.8052
				C102.2761,104.2838,101.9538,105.1407,101.1394,106.0157z M101.8679,103.631c-0.0059-0.0527-0.0137-0.103-0.0234-0.1509
				c-0.0605-0.2891-0.1738-0.502-0.3418-0.6372c-0.168-0.1357-0.373-0.1792-0.6152-0.1294
				c-0.1992,0.041-0.3535,0.1421-0.4648,0.3013c-0.1113,0.1582-0.1445,0.3359-0.1055,0.5322
				c0.041,0.1992,0.1426,0.353,0.3027,0.4595c0.1602,0.1074,0.3398,0.1406,0.5391,0.1001
				C101.4421,104.048,101.6785,103.8898,101.8679,103.631z"/>
      </g>
      <g>
        <path fill="#231F20" d="M95.8455,98.5695l-0.0977-0.2261c0.127-0.2148,0.3184-0.3779,0.5781-0.4893
				c0.2754-0.1182,0.5332-0.1406,0.7734-0.0664c0.2402,0.0737,0.4092,0.2275,0.5088,0.459c0.0713,0.166,0.0859,0.335,0.043,0.5063
				c-0.042,0.1724-0.1445,0.3267-0.3066,0.4644l0.0039,0.0093c0.4678-0.0386,0.7871,0.1421,0.958,0.5415
				c0.1201,0.2793,0.1221,0.54,0.0049,0.7822c-0.1162,0.2432-0.3037,0.4199-0.5615,0.5303
				c-0.2617,0.1123-0.5264,0.1646-0.7949,0.1562l-0.0918-0.2163c0.2598,0.0073,0.5146-0.0425,0.7646-0.1499
				c0.2188-0.0938,0.3701-0.231,0.4521-0.4131c0.083-0.1826,0.0811-0.3735-0.0049-0.5737c-0.0928-0.2153-0.2383-0.356-0.4365-0.4214
				c-0.1982-0.0659-0.4248-0.042-0.6777,0.0713l-0.0947-0.2217c0.2314-0.0996,0.3936-0.2393,0.4863-0.4209
				c0.0908-0.1816,0.1006-0.356,0.0283-0.5254c-0.0723-0.167-0.2012-0.2788-0.3877-0.333
				c-0.1865-0.0547-0.3838-0.0376-0.5898,0.0508C96.1775,98.1813,95.991,98.3424,95.8455,98.5695z"/>
        <path fill="#231F20" d="M98.7908,96.7965c0.2832-0.1211,0.584-0.0815,0.8994,0.1191c0.3174,0.2002,0.5869,0.562,0.8105,1.083
				c0.208,0.4858,0.2803,0.916,0.2148,1.2896c-0.0654,0.3745-0.2402,0.623-0.5244,0.7456c-0.2988,0.1279-0.6055,0.0889-0.918-0.1172
				c-0.3135-0.2051-0.5703-0.543-0.7715-1.0107c-0.25-0.584-0.3311-1.0527-0.2412-1.4072S98.5271,96.9098,98.7908,96.7965z
				 M100.0769,99.8199c0.2354-0.1011,0.3682-0.3145,0.3975-0.6416s-0.043-0.6934-0.2178-1.1006
				c-0.1709-0.3994-0.3838-0.7002-0.6357-0.9053c-0.2529-0.2036-0.498-0.2559-0.7344-0.1543
				c-0.2236,0.0957-0.3525,0.3047-0.3867,0.6279c-0.0352,0.3232,0.0361,0.6909,0.2129,1.104
				c0.1797,0.4175,0.3955,0.7241,0.6484,0.9204C99.614,99.8663,99.8533,99.9156,100.0769,99.8199z"/>
      </g>
      <g>
        <path fill="#231F20" d="M93.0076,94.0206l-0.1406-0.2017c0.0801-0.2354,0.2363-0.4346,0.4678-0.5957
				c0.2471-0.1714,0.4951-0.2451,0.7451-0.2202c0.248,0.0234,0.4463,0.1401,0.5898,0.3467c0.1035,0.1484,0.1514,0.311,0.1445,0.4873
				c-0.0078,0.1772-0.0762,0.3491-0.207,0.5166l0.0059,0.0078c0.4502-0.1313,0.7988-0.0186,1.0469,0.3384
				c0.1738,0.249,0.2285,0.5039,0.1631,0.7646c-0.0654,0.2617-0.2129,0.4722-0.4434,0.6323
				c-0.2344,0.1631-0.4834,0.2676-0.7471,0.313l-0.1348-0.1934c0.2559-0.0449,0.4961-0.1455,0.7197-0.3008
				c0.1943-0.1357,0.3154-0.3003,0.3594-0.4956c0.0439-0.1948,0.0049-0.3823-0.1201-0.561
				c-0.1338-0.1924-0.3047-0.3003-0.5127-0.3247s-0.4248,0.0439-0.6494,0.2065l-0.1367-0.1982
				c0.207-0.144,0.3369-0.3135,0.3906-0.5103c0.0527-0.1963,0.0273-0.3691-0.0781-0.5205c-0.1035-0.1489-0.252-0.2319-0.4473-0.2476
				c-0.1934-0.0156-0.3828,0.04-0.5664,0.1685C93.2546,93.5734,93.1052,93.7692,93.0076,94.0206z"/>
        <path fill="#231F20" d="M95.6648,91.6564l1.9639,2.8213l-0.21,0.1465l-1.9639-2.8213L95.6648,91.6564z"/>
      </g>
      <g>
        <path fill="#231F20" d="M90.5701,88.1954l2.4912,2.3687l-0.1768,0.186l-2.4912-2.3687L90.5701,88.1954z"/>
      </g>
      <g>
        <path fill="#231F20" d="M85.6218,86.2057l-0.2559-0.1602c-0.043-0.3252,0.0098-0.6074,0.1582-0.8457
				c0.1484-0.2378,0.3555-0.3892,0.6211-0.4536s0.5156-0.0244,0.75,0.1216c0.4629,0.2891,0.8789,1.0444,1.248,2.2681l0.8457-1.3574
				l0.2012,0.125l-1.1562,1.8525c-0.3047-1.4414-0.7285-2.3311-1.2695-2.6685c-0.1816-0.1123-0.3711-0.1431-0.5723-0.0942
				c-0.1992,0.0483-0.3574,0.1655-0.4727,0.3511c-0.0762,0.1221-0.1211,0.248-0.1309,0.3765
				C85.5769,85.8497,85.5886,86.0118,85.6218,86.2057z"/>
      </g>
      <g>
        <path fill="#231F20" d="M80.4158,83.7775l-0.2305-0.0854c-0.0693-0.2393-0.0547-0.4912,0.043-0.7559
				c0.1045-0.2817,0.2656-0.4834,0.4854-0.6064c0.2178-0.123,0.4463-0.1396,0.6826-0.0522c0.1699,0.063,0.3027,0.1685,0.3965,0.3169
				c0.0957,0.1499,0.1377,0.3301,0.125,0.543l0.0098,0.0029c0.2949-0.3647,0.6455-0.4717,1.0527-0.3213
				c0.2852,0.1055,0.4756,0.2842,0.5703,0.5352c0.0967,0.252,0.0947,0.5098-0.002,0.7725
				c-0.0996,0.2676-0.2441,0.4956-0.4346,0.6836l-0.2207-0.0815c0.1846-0.1831,0.3232-0.4028,0.4189-0.6587
				c0.082-0.2227,0.0869-0.4268,0.0117-0.6113c-0.0752-0.1855-0.2148-0.3164-0.4199-0.3921
				c-0.2188-0.0815-0.4219-0.0723-0.6055,0.0259c-0.1846,0.0986-0.3232,0.2793-0.415,0.5405l-0.2256-0.0835
				c0.0869-0.2373,0.0977-0.4512,0.0293-0.6426s-0.1875-0.3184-0.3613-0.3828c-0.1699-0.063-0.3398-0.0464-0.5088,0.0518
				c-0.167,0.0977-0.291,0.252-0.3691,0.4629C80.363,83.2692,80.3513,83.5153,80.4158,83.7775z"/>
      </g>
      <g>
        <path fill="#231F20" d="M74.6838,81.0611l1.9268,0.2954l0.0723-0.4741l0.2041,0.0312l-0.0723,0.4741l1.3115,0.2007
				l-0.0391,0.2529l-1.3115-0.2007l-0.2373,1.5498l-0.083-0.0127l-1.7861-2.0215L74.6838,81.0611z M76.5715,81.6095l-1.4326-0.2197
				l1.249,1.418L76.5715,81.6095z"/>
      </g>
      <g>
        <path fill="#231F20" d="M68.7952,81.0748l0.2383-0.0127l0.0615,1.2148l1.0869-0.0557c-0.0195-0.0918-0.0317-0.1836-0.0361-0.2734
				c-0.0176-0.3428,0.064-0.623,0.2461-0.8408c0.1826-0.2178,0.436-0.335,0.7593-0.3516c0.3184-0.0156,0.5884,0.0762,0.8101,0.2764
				c0.2227,0.2012,0.3418,0.4609,0.3579,0.7783c0.0132,0.2656-0.0479,0.5449-0.1841,0.8379l-0.293,0.0146
				c0.1694-0.3291,0.2471-0.6123,0.2354-0.8496c-0.0127-0.2461-0.103-0.4443-0.272-0.5947
				c-0.1675-0.1514-0.3755-0.2207-0.6216-0.208c-0.2676,0.0137-0.4731,0.1084-0.6172,0.2852
				c-0.1426,0.1768-0.2075,0.4053-0.1934,0.6846c0.0078,0.1523,0.04,0.3086,0.0981,0.4688L68.8689,82.53L68.7952,81.0748z"/>
      </g>
      <g>
        <path fill="#231F20" d="M62.9978,82.5406l0.1396-0.1914c0.6865,0.582,1.3447,0.8516,1.9736,0.8105
				c-0.2344-0.1885-0.3838-0.4111-0.4502-0.6689c-0.0684-0.2646-0.0391-0.5088,0.0889-0.7314
				c0.127-0.2236,0.3203-0.3682,0.5771-0.4346c0.2715-0.0703,0.5186-0.04,0.7422,0.0928c0.2217,0.1318,0.3682,0.3359,0.4395,0.6104
				c0.0791,0.3076,0.0371,0.582-0.1279,0.8203c-0.1631,0.2393-0.4238,0.4053-0.7793,0.4971
				C64.7888,83.5563,63.9206,83.2877,62.9978,82.5406z M65.4099,83.1305c0.0605-0.0088,0.1182-0.0195,0.1729-0.0342
				c0.2705-0.0693,0.4678-0.1973,0.5938-0.3828c0.125-0.1846,0.1592-0.3877,0.1016-0.6104
				c-0.0518-0.2012-0.1592-0.3545-0.3223-0.459c-0.1641-0.1025-0.3389-0.1309-0.5283-0.0811
				c-0.2002,0.0518-0.3506,0.165-0.4502,0.3379c-0.1006,0.1729-0.125,0.3604-0.0723,0.5625
				C64.9724,82.7233,65.1404,82.9459,65.4099,83.1305z"/>
      </g>
      <g>
        <path fill="#231F20" d="M57.3567,84.3209l3.8188-0.1221l0.0137,0.2402l-3.4536,0.1133l0.8257,1.6836l-0.2139,0.1055
				L57.3567,84.3209z"/>
      </g>
      <g>
        <path fill="#231F20" d="M54.719,88.0641c0.0229,0.3613-0.0898,0.6387-0.3379,0.8301c-0.1953,0.1523-0.4204,0.2129-0.6748,0.1816
				c-0.2549-0.0312-0.4565-0.1445-0.6064-0.3369c-0.1533-0.1982-0.2148-0.4248-0.1831-0.6768s0.1465-0.4551,0.3438-0.6084
				c0.2554-0.1982,0.5503-0.2412,0.8848-0.1309c-0.0464-0.3916,0.0747-0.6992,0.3628-0.9219
				c0.2178-0.1689,0.4595-0.2373,0.7246-0.2041c0.2642,0.0322,0.4805,0.1562,0.647,0.3711c0.1685,0.2188,0.2383,0.46,0.2065,0.7256
				c-0.0303,0.2656-0.1519,0.4805-0.3633,0.6436C55.427,88.1666,55.093,88.2086,54.719,88.0641z M54.22,88.693
				c0.1479-0.1143,0.2339-0.2617,0.2583-0.4414c0.0249-0.1797-0.019-0.3428-0.1323-0.4902
				c-0.1147-0.1475-0.2612-0.2295-0.4395-0.248c-0.1772-0.0176-0.3438,0.0332-0.4971,0.1523
				c-0.1445,0.1113-0.2285,0.2578-0.252,0.4375c-0.0239,0.1797,0.0205,0.3428,0.1328,0.4883
				c0.1104,0.1426,0.2563,0.2236,0.437,0.2441C53.908,88.8551,54.0725,88.8082,54.22,88.693z M54.6536,86.6119
				c-0.1548,0.1201-0.2432,0.2783-0.2651,0.4746s0.0293,0.374,0.1538,0.5361c0.1216,0.1562,0.2817,0.2461,0.4805,0.2695
				c0.1987,0.0215,0.3774-0.0283,0.5356-0.1504c0.1602-0.125,0.2529-0.2852,0.2793-0.4844s-0.0234-0.3789-0.1489-0.541
				c-0.1274-0.1641-0.2886-0.2568-0.4839-0.2754C55.01,86.4215,54.8254,86.4781,54.6536,86.6119z"/>
      </g>
      <g>
        <path fill="#231F20" d="M51.8557,90.6656L51.842,90.897c-0.9307-0.0791-1.6265,0.0713-2.0859,0.4502
				c0.3145,0.043,0.5625,0.1426,0.7417,0.2959c0.2056,0.1768,0.3188,0.3936,0.3398,0.6504c0.022,0.2568-0.0547,0.4863-0.228,0.6885
				c-0.1812,0.2109-0.3994,0.3262-0.6538,0.3447c-0.2549,0.0186-0.4888-0.0645-0.7031-0.248
				c-0.248-0.2129-0.3735-0.4619-0.3774-0.749s0.1157-0.5713,0.3579-0.8535C49.7903,90.8278,50.6643,90.5572,51.8557,90.6656z
				 M49.5242,91.5494c-0.0381,0.0361-0.0732,0.0732-0.1055,0.1123c-0.1919,0.2227-0.291,0.4434-0.2954,0.6582
				c-0.0044,0.2168,0.0874,0.4043,0.2754,0.5664c0.1543,0.1318,0.3286,0.1934,0.522,0.1816
				c0.1929-0.0078,0.355-0.0898,0.4854-0.2422c0.1333-0.1543,0.1924-0.3271,0.1787-0.5195
				c-0.0132-0.1914-0.0972-0.3535-0.2515-0.4863C50.114,91.6315,49.8445,91.5416,49.5242,91.5494z"/>
      </g>
      <g>
        <path fill="#231F20" d="M47.1614,98.4645l1.6685-3.0059l0.2241,0.125l-1.6685,3.0059L47.1614,98.4645z"/>
        <path fill="#231F20" d="M45.0466,97.3414c-0.27-0.1494-0.4224-0.4111-0.457-0.7832c-0.0356-0.374,0.0854-0.8086,0.3608-1.3047
				c0.2563-0.4619,0.5527-0.7822,0.8877-0.959c0.3359-0.1777,0.6396-0.1914,0.9111-0.041c0.2842,0.1582,0.4404,0.4238,0.4692,0.7969
				c0.0293,0.374-0.0801,0.7832-0.3271,1.2295c-0.3086,0.5557-0.6299,0.9053-0.9653,1.0518S45.2976,97.4811,45.0466,97.3414z
				 M46.6497,94.4742c-0.2241-0.124-0.4741-0.0986-0.7505,0.0781c-0.2764,0.1777-0.5215,0.459-0.7368,0.8467
				c-0.2104,0.3789-0.3193,0.7314-0.3267,1.0566c-0.0063,0.3252,0.1021,0.5498,0.3276,0.6748
				c0.2124,0.1182,0.4565,0.0918,0.7334-0.0781c0.2764-0.1699,0.5239-0.4521,0.7422-0.8447
				c0.2202-0.3975,0.3306-0.7559,0.3306-1.0762C46.9695,94.8121,46.863,94.5934,46.6497,94.4742z"/>
      </g>
      <g>
        <path fill="#231F20" d="M45.2986,103.7184l1.0288-3.2793l0.2446,0.0762l-1.0293,3.2803L45.2986,103.7184z"/>
        <path fill="#231F20" d="M42.8933,102.9645l1.0293-3.2803l0.2446,0.0771l-1.0288,3.2793L42.8933,102.9645z"/>
      </g>
      <g>
        <path fill="#231F20" d="M44.531,109.2379l0.3477-3.4199l0.2549,0.0254l-0.3477,3.4199L44.531,109.2379z"/>
        <path fill="#231F20" d="M43.2346,108.5328l-0.0308,0.3018c-0.2739,0.1807-0.5508,0.2578-0.8301,0.2295
				c-0.2788-0.0283-0.5054-0.1484-0.6802-0.3584c-0.1753-0.21-0.2485-0.4502-0.2207-0.7256c0.0552-0.543,0.5503-1.25,1.4868-2.1191
				l-1.5918-0.1621l0.0239-0.2354l2.1719,0.2207c-1.1592,0.9102-1.7715,1.6816-1.8359,2.3164
				c-0.0215,0.2109,0.0337,0.3955,0.1665,0.5537c0.1318,0.1592,0.3066,0.249,0.5239,0.2715c0.1436,0.0146,0.2754-0.002,0.396-0.0488
				C42.9343,108.7301,43.074,108.6481,43.2346,108.5328z"/>
      </g>
      <g>
        <path fill="#231F20" d="M44.8894,114.7975l-0.3477-3.4199l0.2549-0.0264l0.3477,3.4199L44.8894,114.7975z"/>
        <path fill="#231F20" d="M43.3464,114.5289l0.0244,0.2451c-0.1846,0.167-0.417,0.2656-0.6973,0.2939
				c-0.2988,0.0303-0.5508-0.0259-0.7578-0.1685c-0.207-0.1421-0.3223-0.3394-0.3477-0.5903
				c-0.0186-0.1797,0.0176-0.3452,0.1094-0.4956c0.0928-0.1514,0.2363-0.2686,0.4326-0.3511l-0.001-0.0098
				c-0.458-0.104-0.709-0.3716-0.7529-0.8042c-0.0303-0.3018,0.0459-0.5513,0.2295-0.7476c0.1836-0.1973,0.415-0.3096,0.6943-0.3379
				c0.2842-0.0293,0.5527,0.001,0.8057,0.0894l0.0234,0.2334c-0.2451-0.0845-0.5039-0.1133-0.7754-0.0854
				c-0.2363,0.0239-0.4209,0.1099-0.5547,0.2583c-0.1338,0.1489-0.1895,0.332-0.167,0.5488c0.0234,0.2334,0.1211,0.4111,0.29,0.5327
				c0.1699,0.123,0.3936,0.1675,0.668,0.1348l0.0244,0.2402c-0.251,0.0254-0.4473,0.1104-0.5898,0.2563
				c-0.1416,0.1455-0.2031,0.3096-0.1846,0.4932c0.0186,0.1807,0.1084,0.3257,0.2705,0.4331
				c0.1621,0.1069,0.3545,0.1504,0.5781,0.1279C42.9128,114.8009,43.1394,114.7028,43.3464,114.5289z"/>
      </g>
      <g>
        <path fill="#231F20" d="M46.3621,120.1754l-1.0293-3.2803l0.2441-0.0771l1.0293,3.2803L46.3621,120.1754z"/>
        <path fill="#231F20" d="M43.4841,121.1246l-0.583-1.8594l-0.458,0.1436l-0.0625-0.1973l0.458-0.1436l-0.3965-1.2656
				l0.2441-0.0771l0.3965,1.2656l1.4961-0.4697l0.0254,0.0801l-1.0283,2.4941L43.4841,121.1246z M43.1453,119.1881l0.4336,1.3828
				l0.7227-1.7451L43.1453,119.1881z"/>
      </g>
      <g>
        <path fill="#231F20" d="M48.8855,125.1432l-1.668-3.0059l0.2246-0.124l1.668,3.0049L48.8855,125.1432z"/>
        <path fill="#231F20" d="M46.1921,126.6383l-0.1162-0.208l1.0635-0.5898l-0.5283-0.9512
				c-0.0742,0.0576-0.1514,0.1094-0.2295,0.1533c-0.3008,0.166-0.5879,0.2148-0.8633,0.1484
				c-0.2764-0.0684-0.4932-0.2441-0.6504-0.5273c-0.1543-0.2783-0.1914-0.5625-0.1094-0.8486
				c0.084-0.2891,0.2637-0.5098,0.542-0.6641c0.2324-0.1289,0.5098-0.1963,0.833-0.2041l0.1416,0.2559
				c-0.3701-0.0059-0.6582,0.0488-0.8662,0.1641c-0.2148,0.1191-0.3535,0.2881-0.4141,0.5059
				c-0.0615,0.2178-0.0332,0.4346,0.0869,0.6494c0.1299,0.2354,0.3057,0.3779,0.5283,0.4287
				c0.2207,0.0508,0.4551,0.0078,0.6992-0.1279c0.1338-0.0742,0.2598-0.1729,0.377-0.2949l0.7793,1.4033L46.1921,126.6383z"/>
      </g>
      <g>
        <path fill="#231F20" d="M52.3542,129.5006l-2.2383-2.6084l0.1943-0.167l2.2393,2.6084L52.3542,129.5006z"/>
        <path fill="#231F20" d="M50.2038,131.4068l-0.2334-0.041c0.2197-0.873,0.1719-1.583-0.1416-2.1299
				c-0.0664,0.2939-0.2012,0.5264-0.4023,0.6992c-0.207,0.1787-0.4395,0.2598-0.6953,0.2422
				c-0.2578-0.0156-0.4727-0.125-0.6445-0.3262c-0.1836-0.2129-0.2637-0.4482-0.2432-0.707
				c0.0205-0.2578,0.1396-0.4785,0.3545-0.6631c0.2412-0.208,0.5059-0.29,0.793-0.248c0.2861,0.042,0.5498,0.2031,0.7891,0.4814
				C50.3269,129.3512,50.4675,130.2496,50.2038,131.4068z M49.6706,128.9801c-0.0332-0.0488-0.0684-0.0957-0.1055-0.1387
				c-0.1826-0.2119-0.3848-0.334-0.6055-0.3652c-0.2217-0.0312-0.4189,0.0283-0.5938,0.1777
				c-0.1582,0.1367-0.248,0.2998-0.2695,0.4912c-0.0195,0.1924,0.0332,0.3623,0.1602,0.5107
				c0.1348,0.1572,0.3008,0.2432,0.502,0.2559c0.1992,0.0137,0.3779-0.0479,0.5361-0.1836
				C49.4988,129.5533,49.6238,129.3043,49.6706,128.9801z"/>
      </g>
      <g>
        <path fill="#231F20" d="M56.6355,133.0709l-2.7188-2.1045l0.1562-0.2021l2.7188,2.1045L56.6355,133.0709z"/>
        <path fill="#231F20" d="M54.4753,135.8609l-1.793-3.373l0.2109-0.1191l1.623,3.0508l1.1465-1.4824l0.1895,0.1455
				L54.4753,135.8609z"/>
      </g>
      <g>
        <path fill="#231F20" d="M61.5437,135.7086l-3.0859-1.5137l0.1133-0.2305l3.0859,1.5137L61.5437,135.7086z"/>
        <path fill="#231F20" d="M59.2136,136.7164c0.3145-0.1797,0.6133-0.2002,0.8945-0.0625c0.2217,0.1094,0.375,0.2852,0.459,0.5264
				c0.084,0.2432,0.0723,0.4736-0.0352,0.6934c-0.1104,0.2246-0.2861,0.3789-0.5264,0.4619
				c-0.2412,0.082-0.4736,0.0693-0.6973-0.041c-0.29-0.1426-0.46-0.3867-0.5078-0.7363c-0.3311,0.2139-0.6602,0.2402-0.9873,0.0801
				c-0.2471-0.1211-0.415-0.3076-0.502-0.5605c-0.0879-0.252-0.0713-0.5,0.0479-0.7441c0.1221-0.248,0.3076-0.416,0.5605-0.5049
				c0.252-0.0898,0.498-0.0752,0.7383,0.043C58.9939,136.0358,59.1785,136.318,59.2136,136.7164z M57.9382,137.4156
				c0.1758,0.0859,0.3574,0.0957,0.543,0.0283c0.1855-0.0664,0.3232-0.1914,0.4131-0.374c0.0869-0.1777,0.0977-0.3613,0.0303-0.5498
				s-0.1914-0.3271-0.3711-0.415c-0.1816-0.0889-0.3662-0.1016-0.5566-0.0371c-0.1895,0.0635-0.3301,0.1875-0.4209,0.3721
				c-0.0908,0.1865-0.1025,0.3721-0.0342,0.5557S57.7429,137.319,57.9382,137.4156z M59.9988,136.8883
				c-0.168-0.083-0.3379-0.0957-0.5098-0.0381c-0.1729,0.0566-0.3008,0.168-0.3828,0.335c-0.082,0.168-0.0918,0.3359-0.0293,0.5029
				s0.1816,0.2949,0.3555,0.3809c0.1641,0.0801,0.332,0.0908,0.5039,0.0332c0.1719-0.0586,0.2988-0.1699,0.3799-0.335
				c0.0791-0.1621,0.0869-0.3291,0.0264-0.5C60.281,137.0963,60.1658,136.9703,59.9988,136.8883z"/>
      </g>
      <g>
        <path fill="#231F20" d="M66.8816,137.3033l-3.3271-0.8613l0.0645-0.248l3.3271,0.8613L66.8816,137.3033z"/>
        <path fill="#231F20" d="M63.0447,138.232l0.2139-0.0898c0.3389,0.8711,0.7812,1.4287,1.3242,1.6738
				c-0.1006-0.3008-0.1211-0.5674-0.0625-0.7959c0.0684-0.2617,0.2129-0.459,0.4346-0.5918
				c0.2207-0.1318,0.4609-0.165,0.7188-0.0986c0.2695,0.0703,0.4697,0.2148,0.5977,0.4365
				c0.1289,0.2197,0.1572,0.4668,0.0869,0.7393c-0.082,0.3164-0.251,0.5391-0.5068,0.6699
				c-0.2549,0.1289-0.5635,0.1475-0.9238,0.0537C64.0994,140.0152,63.4724,139.3492,63.0447,138.232z M64.866,139.9361
				c0.0498,0.0176,0.0977,0.0322,0.1465,0.0449c0.2852,0.0742,0.5264,0.0664,0.7217-0.0244
				c0.1963-0.0918,0.3242-0.2568,0.3867-0.4961c0.0508-0.1973,0.0283-0.3809-0.0664-0.5498
				c-0.0928-0.1689-0.2373-0.2783-0.4307-0.3291c-0.1982-0.0508-0.3789-0.0283-0.5459,0.0684s-0.2754,0.2432-0.3262,0.4404
				C64.6794,139.3697,64.7175,139.652,64.866,139.9361z"/>
      </g>
      <g>
        <path fill="#231F20" d="M71.9236,136.6041l0.3027,0.0146c0.1953,0.2646,0.2861,0.5371,0.2725,0.8174
				c-0.0146,0.2803-0.1221,0.5127-0.3232,0.6982c-0.2021,0.1855-0.4385,0.2715-0.7148,0.2568
				c-0.5449-0.0273-1.2754-0.4863-2.1914-1.377l-0.0811,1.5977l-0.2363-0.0127l0.1104-2.1807
				c0.9678,1.1123,1.7705,1.6846,2.4072,1.7168c0.2119,0.0107,0.3926-0.0537,0.5439-0.1943
				c0.1523-0.1396,0.2334-0.3193,0.2451-0.5371c0.0068-0.1436-0.0156-0.2754-0.0693-0.3926
				C72.1365,136.8941,72.0476,136.7574,71.9236,136.6041z"/>
        <path fill="#231F20" d="M72.3591,140.1832c-0.0156,0.3086-0.1846,0.5605-0.5039,0.7559
				c-0.3193,0.1963-0.7627,0.2793-1.3291,0.251c-0.5273-0.0273-0.9463-0.1523-1.252-0.375
				c-0.3076-0.2236-0.4541-0.4902-0.4385-0.7998c0.0166-0.3242,0.1865-0.582,0.5098-0.7725
				c0.3213-0.1904,0.7383-0.2734,1.2471-0.2471c0.6348,0.0322,1.0908,0.166,1.3701,0.4033
				C72.241,139.6354,72.3738,139.8971,72.3591,140.1832z M69.0779,140.0074c-0.0127,0.2559,0.1201,0.4688,0.4004,0.6387
				c0.2812,0.1709,0.6416,0.2666,1.085,0.2891c0.4326,0.0225,0.7969-0.0352,1.0918-0.1719c0.2949-0.1377,0.4502-0.335,0.4629-0.5918
				c0.0127-0.2422-0.1191-0.4502-0.3945-0.623c-0.2744-0.1738-0.6357-0.2715-1.084-0.2949
				c-0.4531-0.0225-0.8242,0.0361-1.1123,0.1768C69.24,139.5709,69.0906,139.7643,69.0779,140.0074z"/>
      </g>
      <g>
        <path fill="#231F20" d="M77.2302,136.0904l0.2988-0.0459c0.2437,0.2197,0.3877,0.4688,0.4302,0.7461
				c0.0425,0.2764-0.0161,0.5264-0.1753,0.748c-0.1597,0.2227-0.3745,0.3545-0.6479,0.3965c-0.54,0.082-1.3481-0.2207-2.4238-0.9082
				l0.2422,1.5811l-0.2344,0.0352l-0.3306-2.1572c1.1714,0.8945,2.0723,1.293,2.7031,1.1963
				c0.209-0.0322,0.3735-0.1318,0.4946-0.2998c0.1206-0.168,0.1641-0.3594,0.1309-0.5752c-0.022-0.1426-0.0708-0.2666-0.147-0.3701
				C77.4963,136.3316,77.3816,136.2164,77.2302,136.0904z"/>
        <path fill="#231F20" d="M78.3513,139.6412l-3.3984,0.5205l-0.0391-0.2539l3.3984-0.5205L78.3513,139.6412z"/>
      </g>
      <g>
        <path fill="#231F20" d="M82.3269,134.5191l0.2832-0.1055c0.2832,0.166,0.4746,0.3799,0.5723,0.6436s0.0898,0.5195-0.0215,0.7695
				c-0.1113,0.249-0.2969,0.4219-0.5557,0.5176c-0.5117,0.1895-1.3643,0.0557-2.5576-0.4023l0.5557,1.501l-0.2217,0.082
				l-0.7578-2.0479c1.3271,0.6406,2.29,0.8506,2.8887,0.6289c0.1982-0.0742,0.3398-0.2051,0.4238-0.3936
				s0.0879-0.3857,0.0117-0.5898c-0.0488-0.1357-0.1221-0.2471-0.2168-0.333C82.6355,134.7018,82.4997,134.6119,82.3269,134.5191z"
        />
        <path fill="#231F20" d="M83.2019,136.8824l0.2832-0.1055c0.2832,0.166,0.4746,0.3799,0.5723,0.6436s0.0898,0.5195-0.0215,0.7686
				c-0.1113,0.25-0.2959,0.4229-0.5557,0.5186c-0.5117,0.1895-1.3643,0.0557-2.5571-0.4023l0.5557,1.5l-0.2217,0.082l-0.7583-2.0469
				c1.3276,0.6406,2.29,0.8506,2.8887,0.6289c0.1982-0.0742,0.3398-0.2051,0.4238-0.3936s0.0879-0.3857,0.0127-0.5898
				c-0.0498-0.1357-0.1221-0.2471-0.2178-0.334S83.3757,136.9752,83.2019,136.8824z"/>
      </g>
      <g>
        <path fill="#231F20" d="M86.9988,131.9557l0.2578-0.1602c0.3105,0.1055,0.541,0.2773,0.6895,0.5156s0.1934,0.4902,0.1338,0.7578
				c-0.0596,0.2656-0.2041,0.4727-0.4385,0.6182c-0.4639,0.2891-1.3262,0.3291-2.5859,0.1221l0.8457,1.3574l-0.2012,0.125
				l-1.1543-1.8535c1.4297,0.3613,2.4141,0.3711,2.9551,0.0352c0.1807-0.1133,0.293-0.2695,0.3359-0.4707
				c0.0449-0.2021,0.0098-0.3955-0.1055-0.5811c-0.0762-0.1221-0.1699-0.2168-0.2812-0.2822
				C87.3386,132.0729,87.1882,132.0113,86.9988,131.9557z"/>
        <path fill="#231F20" d="M88.5359,134.1412l0.209-0.1299c0.2305,0.0918,0.4219,0.2568,0.5703,0.4971
				c0.1592,0.2549,0.2207,0.5059,0.1826,0.7539c-0.0361,0.248-0.1621,0.4395-0.376,0.5723
				c-0.1533,0.0957-0.3184,0.1357-0.4941,0.1201c-0.1758-0.0166-0.3447-0.0938-0.5049-0.2334l-0.0088,0.0049
				c0.1094,0.4561-0.0215,0.7998-0.3906,1.0293c-0.2578,0.1611-0.5146,0.2021-0.7715,0.124
				c-0.2578-0.0781-0.4609-0.2363-0.6094-0.4746c-0.1504-0.2422-0.2422-0.4961-0.2754-0.7617l0.2002-0.125
				c0.0322,0.2578,0.1201,0.5029,0.2646,0.7344c0.125,0.2012,0.2832,0.3301,0.4766,0.3838
				c0.1924,0.0537,0.3809,0.0225,0.5664-0.0928c0.1982-0.123,0.3145-0.2891,0.3496-0.4941c0.0352-0.207-0.0225-0.4268-0.1729-0.6592
				l0.2041-0.1279c0.1338,0.2148,0.2969,0.3535,0.4902,0.417s0.3672,0.0459,0.5234-0.0518
				c0.1543-0.0957,0.2451-0.2402,0.2715-0.4336c0.0244-0.1914-0.0215-0.3848-0.1406-0.5742
				C88.9705,134.4108,88.782,134.2506,88.5359,134.1412z"/>
      </g>
      <g>
        <path fill="#231F20" d="M91.0622,128.5006l0.2197-0.209c0.3262,0.041,0.5859,0.1631,0.7793,0.3662
				c0.1934,0.2041,0.2871,0.4424,0.2832,0.7158s-0.1055,0.5039-0.3057,0.6934c-0.3955,0.377-1.2314,0.5898-2.5088,0.6406
				l1.1025,1.1602l-0.1709,0.1621l-1.5039-1.582c1.4717,0.0645,2.4395-0.123,2.9014-0.5625
				c0.1533-0.1455,0.2314-0.3213,0.2344-0.5283c0.0029-0.2061-0.0703-0.3887-0.2207-0.5469c-0.0986-0.1045-0.21-0.1787-0.332-0.2207
				S91.2585,128.5182,91.0622,128.5006z"/>
        <path fill="#231F20" d="M94.3943,131.1119l-1.4131,1.3438l0.3311,0.3477l-0.1494,0.1426l-0.332-0.3477l-0.9609,0.9141
				l-0.1758-0.1855l0.9609-0.9141l-1.0801-1.1367l0.0605-0.0576l2.6934-0.1758L94.3943,131.1119z M92.8054,132.2701l1.0498-0.998
				l-1.8857,0.1191L92.8054,132.2701z"/>
      </g>
      <g>
        <path fill="#231F20" d="M94.3474,124.3024l0.1729-0.249c0.3262-0.0264,0.6064,0.042,0.8369,0.2021
				c0.2295,0.1602,0.3701,0.374,0.4209,0.6426c0.0518,0.2695-0.001,0.5156-0.1582,0.7422
				c-0.3125,0.4482-1.0889,0.8252-2.3291,1.1309l1.3135,0.9141l-0.1357,0.1943l-1.792-1.2471
				c1.4551-0.2324,2.3652-0.6113,2.7305-1.1348c0.1211-0.1738,0.1621-0.3613,0.123-0.5645s-0.1484-0.3672-0.3281-0.4922
				c-0.1172-0.082-0.2402-0.1318-0.3691-0.1484C94.7058,124.275,94.5427,124.2789,94.3474,124.3024z"/>
        <path fill="#231F20" d="M98.1531,126.2555l-0.1367,0.1963l-0.998-0.6943l-0.6211,0.8926c0.0859,0.041,0.166,0.0879,0.2393,0.1387
				c0.2822,0.1963,0.4521,0.4326,0.5146,0.709c0.0586,0.2783-0.002,0.5508-0.1875,0.8164
				c-0.1816,0.2617-0.4209,0.4189-0.7148,0.4707c-0.2949,0.0537-0.5723-0.0117-0.834-0.1934
				c-0.2188-0.1523-0.4014-0.3711-0.5498-0.6572l0.167-0.2412c0.1572,0.3359,0.334,0.5703,0.5293,0.707
				c0.2012,0.1406,0.4141,0.1895,0.6357,0.1484c0.2227-0.041,0.4053-0.1621,0.5449-0.3652
				c0.1533-0.2197,0.2041-0.4394,0.1533-0.6621c-0.0527-0.2207-0.1934-0.4121-0.4238-0.5723
				c-0.125-0.0869-0.2695-0.1562-0.4307-0.209l0.917-1.3164L98.1531,126.2555z"/>
      </g>
      <g>
        <path fill="#231F20" d="M96.7195,119.527l0.1191-0.2793c0.3145-0.0898,0.6025-0.082,0.8604,0.0293s0.4385,0.293,0.542,0.5449
				c0.1045,0.2539,0.1025,0.5059-0.0068,0.7598c-0.2148,0.502-0.8994,1.0273-2.0527,1.5762l1.4697,0.6309l-0.0928,0.2168
				l-2.0068-0.8594c1.3789-0.5215,2.1943-1.0742,2.4453-1.6621c0.084-0.1934,0.0859-0.3867,0.0078-0.5781
				c-0.0791-0.1895-0.2188-0.3281-0.4189-0.4141c-0.1328-0.0566-0.2637-0.082-0.3926-0.0723
				C97.0642,119.4274,96.906,119.4645,96.7195,119.527z"/>
        <path fill="#231F20" d="M100.6677,120.5524l0.0664,0.2266c-0.8809,0.1875-1.4971,0.543-1.8496,1.0645
				c0.293-0.0703,0.5605-0.0508,0.8047,0.0527c0.252,0.1094,0.4268,0.2812,0.5244,0.5195c0.0986,0.2363,0.0957,0.4785-0.0098,0.7227
				c-0.1104,0.2578-0.2861,0.4336-0.5273,0.5293c-0.2402,0.0938-0.4912,0.0859-0.752-0.0273
				c-0.292-0.125-0.4824-0.3262-0.5713-0.6016s-0.0605-0.584,0.085-0.9219C98.7693,121.3453,99.5124,120.8238,100.6677,120.5524z
				 M98.7244,122.0973c-0.0293,0.0527-0.0557,0.1055-0.0781,0.1582c-0.1104,0.2559-0.1299,0.4902-0.0605,0.7031
				s0.209,0.3633,0.4209,0.4551c0.1914,0.082,0.377,0.0898,0.5586,0.0254c0.1826-0.0664,0.3115-0.1895,0.3887-0.3691
				c0.082-0.1895,0.085-0.377,0.0088-0.5625s-0.21-0.3184-0.4014-0.4004C99.3152,122.0016,99.0349,121.9977,98.7244,122.0973z"/>
      </g>
      <g>
        <path fill="#231F20" d="M98.0808,114.3717l0.0605-0.2969c0.291-0.1523,0.5742-0.2012,0.8496-0.1445
				c0.2744,0.0566,0.4883,0.1982,0.6406,0.4248s0.2012,0.4746,0.1465,0.7451c-0.1104,0.5352-0.6748,1.1875-1.6943,1.958
				l1.5674,0.3223l-0.0479,0.2314l-2.1377-0.4395c1.2451-0.7891,1.9316-1.4941,2.0605-2.1191
				c0.043-0.208,0.0059-0.3965-0.1094-0.5684c-0.1162-0.1709-0.2803-0.2783-0.4941-0.3223
				c-0.1416-0.0293-0.2744-0.0273-0.3984,0.0088C98.3992,114.2057,98.2517,114.2731,98.0808,114.3717z"/>
        <path fill="#231F20" d="M102.7878,114.7565l-2.2402,3.0947l-0.1992-0.1367l2.0234-2.7998l-1.8359-0.3779l0.0488-0.2334
				L102.7878,114.7565z"/>
      </g>
    </g>
  </g>
  <g v-else-if="calendar.role === 'timeWeekday'" :id="calendar.id" class="calendar__weekday-disc">
    <path fill="#FFFFFF" d="M71.9778,85.1762c-13.6984,0-24.8032,11.1048-24.8032,24.8031s11.1048,24.8032,24.8032,24.8032
			s24.8031-11.1048,24.8031-24.8031S85.6763,85.1762,71.9778,85.1762z M71.9778,120.6091c-5.8707,0-10.6299-4.7592-10.6299-10.6299
			s4.7592-10.6299,10.6299-10.6299s10.6299,4.7592,10.6299,10.6299S77.8486,120.6091,71.9778,120.6091z"/>
    <g>
      <g>
        <g>
          <path fill="#231F20" d="M85.4297,109.7305l1.3057-1.5967h0.2695v3.4375h-0.2686v-3.0488l-1.3076,1.6074l-1.3135-1.6074v3.0488
						h-0.2656v-3.4375h0.2656L85.4297,109.7305z"/>
          <path fill="#231F20" d="M89.4678,108.0894c0.5088,0,0.9395,0.1714,1.293,0.5132c0.3535,0.3423,0.5303,0.7593,0.5303,1.2515
						c0,0.4907-0.1768,0.9067-0.5303,1.2485s-0.7842,0.5137-1.293,0.5137c-0.5068,0-0.9365-0.1719-1.2881-0.5137
						c-0.3525-0.3418-0.5283-0.7578-0.5283-1.2485c0-0.4922,0.1758-0.9092,0.5283-1.2515
						C88.5312,108.2607,88.9609,108.0894,89.4678,108.0894z M89.4775,111.3701c0.4277,0,0.7891-0.1465,1.084-0.4395
						s0.4414-0.6519,0.4414-1.0767c0-0.4263-0.1465-0.7861-0.4414-1.0791s-0.6562-0.4395-1.084-0.4395
						c-0.4297,0-0.7939,0.1465-1.0918,0.4395s-0.4463,0.6528-0.4463,1.0791c0,0.4248,0.1484,0.7837,0.4463,1.0767
						S89.0479,111.3701,89.4775,111.3701z"/>
          <path fill="#231F20" d="M95.0371,108.1338v3.4375h-0.2188l-2.6143-3.0044v3.0044h-0.2656v-3.4375h0.2256l2.6074,3.0049v-3.0049
						H95.0371z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M83.1055,102.5801l1.3945,2.8984l1.5332-0.7383l0.0957,0.1997l-1.7715,0.853l-1.4922-3.0977
						L83.1055,102.5801z"/>
          <path fill="#231F20" d="M87.2812,100.5693l0.2383-0.1152l0.8145,1.6899c0.2227,0.4624,0.2734,0.8774,0.1543,1.2451
						c-0.1211,0.3667-0.3711,0.6431-0.7539,0.8271s-0.752,0.209-1.1133,0.0771c-0.3594-0.1323-0.6445-0.4146-0.8516-0.8462
						l-0.8418-1.7451l0.2422-0.1162l0.8359,1.7363c0.1777,0.3691,0.416,0.6113,0.7109,0.7251
						c0.2969,0.1147,0.5996,0.0972,0.9102-0.0527c0.3145-0.1509,0.5176-0.3784,0.6133-0.6836
						c0.0938-0.3052,0.0469-0.6514-0.1387-1.0386L87.2812,100.5693z"/>
          <path fill="#231F20" d="M90.9551,98.7998l1.4922,3.0977l-0.1973,0.0947l-3.6602-1.5728l1.3047,2.7075l-0.2402,0.1152
						l-1.4902-3.0977l0.2031-0.0977l3.6523,1.5762l-1.3047-2.708L90.9551,98.7998z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M80.4375,96.4268l0.1738,0.1382l-0.8047,1.0088l2.5146,2.0054l-0.167,0.209l-2.5146-2.0054
						l-0.8037,1.0088l-0.1738-0.1382L80.4375,96.4268z"/>
          <path fill="#231F20" d="M82.2803,94.1162l0.165-0.2075l1.4668,1.1694c0.4004,0.3198,0.627,0.6714,0.6787,1.0547
						c0.0518,0.3828-0.0557,0.7407-0.3193,1.0728c-0.2646,0.3315-0.5879,0.5146-0.9707,0.5522
						c-0.3809,0.0371-0.7598-0.0933-1.1348-0.3921l-1.5137-1.2075l0.167-0.21l1.5068,1.2012
						c0.3203,0.2559,0.6387,0.3711,0.9551,0.3447c0.3164-0.0249,0.582-0.1724,0.7969-0.4419
						c0.2168-0.272,0.3008-0.5659,0.2539-0.8813c-0.0469-0.3164-0.2383-0.6084-0.5742-0.876L82.2803,94.1162z"/>
          <path fill="#231F20" d="M84.0664,91.8765l0.1738,0.1382l-1.0039,1.2588l1.0742,0.8574l0.9785-1.2261l0.1758,0.1401
						l-0.9785,1.2261l1.0908,0.8696l1.0283-1.2896l0.1738,0.1382l-1.1943,1.4971l-2.6885-2.1436L84.0664,91.8765z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M74.9238,95.9775l-1.2666-1.6279l0.0605-0.2627l3.3516,0.7646l-0.0596,0.2617l-2.9727-0.6782
						l1.2764,1.6323l-1.8604,0.9233l2.9736,0.6782l-0.0596,0.2588l-3.3516-0.7646l0.0586-0.2588L74.9238,95.9775z"/>
          <path fill="#231F20" d="M74.1709,91.9893l3.7295-0.7793l-0.0615,0.2725l-1.2803,0.2661l-0.374,1.6387l1.0381,0.7925
						l-0.0615,0.2725l-3.0225-2.3203L74.1709,91.9893z M76.3203,91.7983l-1.7432,0.3613l1.4141,1.0801L76.3203,91.7983z"/>
          <path fill="#231F20" d="M74.6406,90.0405l0.1963-0.8584c0.082-0.3599,0.2236-0.6177,0.4229-0.7725s0.4316-0.2017,0.6973-0.1411
						c0.3867,0.0884,0.6104,0.3628,0.6699,0.8242c0.0781-0.0986,0.2822-0.2085,0.6133-0.3301l1.332-0.4932l-0.0703,0.3066
						l-1.0518,0.3745c-0.3516,0.1245-0.5781,0.2329-0.6787,0.3237c-0.1016,0.0913-0.1758,0.2417-0.2236,0.4512l-0.1035,0.4541
						l1.6084,0.3672l-0.0596,0.2588L74.6406,90.0405z M74.917,89.8311l1.3125,0.2993l0.127-0.5571
						c0.0645-0.2827,0.0566-0.5127-0.0244-0.688c-0.0801-0.1763-0.2246-0.2871-0.4346-0.335
						c-0.2061-0.0474-0.3838-0.0083-0.5332,0.1177c-0.1504,0.126-0.2578,0.3311-0.3232,0.6157L74.917,89.8311z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M67.5444,96.2979l3.0854,0.4775l0.0161,0.0693l-3.0781,2.1221l-0.0605-0.2656l2.5273-1.7451
						l-3.0376-0.4902l-0.0181-0.0801l2.5249-1.7549l-3.0347-0.4785l-0.0605-0.2656l3.6943,0.5801l0.0137,0.0615L67.5444,96.2979z"/>
          <path fill="#231F20" d="M65.9038,91.6748l0.2158-0.0498l0.3584,1.5703l1.3408-0.3066l-0.3486-1.5283l0.2188-0.0498
						l0.3486,1.5283l1.3599-0.3096l-0.3667-1.6084l0.2163-0.0498l0.4263,1.8672l-3.3525,0.7656L65.9038,91.6748z"/>
          <path fill="#231F20" d="M65.7725,91.0996l-0.2681-1.1738c-0.1353-0.5938-0.0825-1.082,0.1577-1.4648
						c0.2407-0.3848,0.6079-0.6338,1.1021-0.7461c0.4844-0.1104,0.9204-0.0469,1.3076,0.1904
						c0.3857,0.2373,0.6445,0.6416,0.7744,1.21l0.2783,1.2188L65.7725,91.0996z M65.9292,90.791l2.9199-0.666l-0.2158-0.9453
						c-0.0991-0.4336-0.3145-0.7646-0.647-0.9922c-0.332-0.2285-0.7178-0.292-1.1577-0.1914
						c-0.4307,0.0977-0.749,0.3203-0.9561,0.668c-0.207,0.3467-0.2583,0.7461-0.1553,1.1982L65.9292,90.791z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M62.0083,97.9004l-2.0625-0.0244l-0.168-0.2109l2.6875-2.1436l0.1675,0.21l-2.3838,1.9014
						l2.0723,0.0195l-0.438,2.0293l2.3838-1.9004l0.1655,0.207l-2.6875,2.1436l-0.1655-0.208L62.0083,97.9004z"/>
          <path fill="#231F20" d="M59.1235,96.8438l2.6875-2.1426l0.1655,0.207l-2.6875,2.1436L59.1235,96.8438z"/>
          <path fill="#231F20" d="M57.4595,94.7578l0.1733-0.1387l1.0039,1.2598l1.0752-0.8574l-0.978-1.2266l0.1753-0.1406l0.978,1.2266
						l1.0903-0.8691l-1.0283-1.29l0.1733-0.1377l1.1938,1.4961l-2.6875,2.1445L57.4595,94.7578z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M57.4082,105.0439l0.0967-0.2002l1.1621,0.5605l1.3955-2.8984l0.2412,0.1162l-1.3955,2.8975
						l1.1621,0.5605l-0.0967,0.1992L57.4082,105.0439z"/>
          <path fill="#231F20" d="M54.4814,103.6348l1.4922-3.0977l0.2422,0.1162l-0.707,1.4678l2.0669,0.9951l0.7065-1.4678
						l0.2393,0.1152l-1.4912,3.0977l-0.2393-0.1152l0.6885-1.4297l-2.0669-0.9961l-0.689,1.4307L54.4814,103.6348z"/>
          <path fill="#231F20" d="M51.4795,102.1885l-0.2393-0.1152l0.814-1.6895c0.2227-0.4629,0.5151-0.7617,0.8774-0.8975
						c0.3618-0.1348,0.7339-0.1104,1.1167,0.0742c0.3818,0.1836,0.6323,0.458,0.7544,0.8223
						c0.1216,0.3633,0.0781,0.7617-0.1299,1.1934l-0.8398,1.7461l-0.2422-0.1172l0.8359-1.7363
						c0.1777-0.3691,0.2192-0.7051,0.1235-1.0078c-0.0952-0.3027-0.2983-0.5293-0.6089-0.6787
						c-0.3125-0.1514-0.6182-0.168-0.9155-0.0518c-0.2979,0.1162-0.5396,0.3682-0.7261,0.7549L51.4795,102.1885z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M57.3916,111.8652v-3.438c0-0.3789,0.0723-0.6406,0.2148-0.7852
						c0.1426-0.144,0.3115-0.2163,0.5068-0.2163c0.0459,0,0.0986,0.0029,0.1602,0.0098l0.0244,0.251
						c-0.0557-0.0132-0.1084-0.0195-0.1572-0.0195c-0.3223,0-0.4824,0.2295-0.4824,0.689v3.5093H57.3916z"/>
          <path fill="#231F20" d="M54.0889,111.8652h-0.2656v-1.8755c0-0.5132,0.1338-0.9097,0.4014-1.1885s0.6133-0.4185,1.0381-0.4185
						c0.4238,0,0.7686,0.1382,1.0361,0.4136s0.4014,0.6528,0.4014,1.1318v1.937h-0.2686v-1.9268
						c0-0.4102-0.1084-0.731-0.3262-0.9624c-0.2168-0.2314-0.498-0.3472-0.8428-0.3472c-0.3477,0-0.6299,0.1172-0.8477,0.3506
						c-0.2178,0.2339-0.3262,0.5659-0.3262,0.9956V111.8652z"/>
          <path fill="#231F20" d="M51.2236,111.8652v-0.2217h1.6104v-1.3755h-1.5684v-0.2241h1.5684v-1.395h-1.6494v-0.2217h1.915v3.438
						H51.2236z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M57.9102,118.8564l-0.0967-0.2002l1.3545-0.6523l-0.5664-1.1768l-1.2227,0.5889l-0.0957-0.2002
						l1.2227-0.5889l-0.7324-1.5205l0.2383-0.1152l1.4922,3.0977L57.9102,118.8564z"/>
          <path fill="#231F20" d="M57.5117,119.0488l-0.7939,0.3818c-0.333,0.1602-0.6221,0.21-0.8672,0.1504
						c-0.2451-0.0586-0.4268-0.2109-0.5449-0.457c-0.1729-0.3574-0.0967-0.7031,0.2256-1.0371
						c-0.125,0.001-0.3379-0.0908-0.6396-0.2744l-1.2158-0.7324l0.2832-0.1367l0.9492,0.5889
						c0.3164,0.1973,0.542,0.3066,0.6758,0.3281c0.1348,0.0225,0.2988-0.0127,0.4922-0.1064l0.4199-0.2021l-0.7158-1.4854
						l0.2393-0.1152L57.5117,119.0488z M57.1758,118.9639l-0.584-1.2129l-0.5146,0.248c-0.2617,0.126-0.4365,0.2754-0.5234,0.4473
						c-0.0879,0.1729-0.085,0.3555,0.0088,0.5488c0.0918,0.1904,0.2334,0.3057,0.4248,0.3447
						c0.1924,0.0381,0.4189-0.0059,0.6826-0.1328L57.1758,118.9639z"/>
          <path fill="#231F20" d="M54.6738,120.415l-1.4922-3.0977l0.2402-0.1152l1.4912,3.0977L54.6738,120.415z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M62.752,124.5879l-1.8154-3.293l0.0479-0.0605l3.6172,1.0342l-0.168,0.2109l-3.0332-0.8623
						l1.5195,2.7598L62.752,124.5879z"/>
          <path fill="#231F20" d="M62.332,125.1143l-2.6875-2.1436l0.166-0.208l2.6875,2.1436L62.332,125.1143z"/>
          <path fill="#231F20" d="M60.668,127.2012l-0.1729-0.1387l1.0039-1.2588l-1.0752-0.8574l-0.9785,1.2256l-0.1748-0.1396
						l0.9775-1.2256l-1.0898-0.8701l-1.0293,1.29l-0.1729-0.1387l1.1943-1.498l2.6875,2.1445L60.668,127.2012z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M70.2217,125.3984l-0.2861-0.0654c0.2383-0.252,0.3809-0.4834,0.4287-0.6924
						c0.0459-0.2021,0.0225-0.3828-0.0684-0.5459c-0.0918-0.1641-0.2275-0.2656-0.4082-0.3066
						c-0.1299-0.0293-0.2559-0.0166-0.3779,0.0391c-0.1221,0.0566-0.2598,0.2002-0.4141,0.4326
						c-0.1543,0.2334-0.2773,0.4004-0.3672,0.5029c-0.0908,0.1025-0.2061,0.1797-0.3467,0.2344
						c-0.1396,0.0527-0.3066,0.0576-0.5,0.0137c-0.2578-0.0586-0.4541-0.2021-0.5879-0.4316
						c-0.1348-0.2305-0.1709-0.4795-0.1084-0.752c0.0625-0.2783,0.2266-0.542,0.4883-0.792l0.3047,0.0693
						c-0.3125,0.2705-0.4961,0.5244-0.5508,0.7637c-0.0449,0.1973-0.0186,0.3799,0.0791,0.5459s0.2393,0.2705,0.4268,0.3125
						c0.1426,0.0332,0.2803,0.0205,0.415-0.0381c0.1328-0.0586,0.2793-0.2061,0.4375-0.4434c0.1582-0.2354,0.2803-0.4023,0.3672-0.5
						s0.1943-0.1719,0.3252-0.2246c0.1299-0.0508,0.2842-0.0566,0.4609-0.0156c0.2461,0.0557,0.4346,0.1982,0.5654,0.4258
						c0.1299,0.2285,0.166,0.4756,0.1045,0.7412C70.5508,124.9326,70.4209,125.1748,70.2217,125.3984z"/>
          <path fill="#231F20" d="M69.9453,127.4941l-3.7295,0.7793l0.0615-0.2715l1.2803-0.2666l0.374-1.6387l-1.0381-0.792
						l0.0615-0.2725l3.0225,2.3203L69.9453,127.4941z M67.7959,127.6855l1.7432-0.3613l-1.4141-1.0801L67.7959,127.6855z"/>
          <path fill="#231F20" d="M69.0381,131.3574l-0.2158-0.0488l0.2871-1.2578l-3.1367-0.7158l0.0596-0.2607l3.1357,0.7158
						l0.2871-1.2578l0.2168,0.0488L69.0381,131.3574z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M77.0469,124.5029l-0.2861,0.0654c0.1045-0.3301,0.1338-0.6006,0.085-0.8096
						c-0.0449-0.2021-0.1445-0.3555-0.2979-0.4629s-0.3203-0.1406-0.501-0.0996c-0.1289,0.0293-0.2383,0.0967-0.3232,0.2002
						c-0.085,0.1045-0.1475,0.293-0.1855,0.5693c-0.0381,0.2773-0.0762,0.4805-0.1123,0.6113
						c-0.0371,0.1318-0.1074,0.252-0.2109,0.3613s-0.251,0.1865-0.4443,0.2305c-0.2578,0.0586-0.4971,0.0137-0.7178-0.1338
						c-0.2207-0.1494-0.3613-0.3584-0.4238-0.6309c-0.0635-0.2773-0.0312-0.5869,0.0967-0.9248l0.3047-0.0703
						c-0.1641,0.3789-0.2197,0.6875-0.165,0.9268c0.0449,0.1982,0.1484,0.3506,0.3086,0.458
						c0.1602,0.1064,0.333,0.1396,0.5205,0.0967c0.1416-0.0322,0.2607-0.1035,0.3564-0.2139
						c0.0947-0.1113,0.1621-0.3086,0.2031-0.5898c0.0391-0.2812,0.0771-0.4844,0.1133-0.6094
						c0.0352-0.126,0.0996-0.2402,0.1953-0.3438c0.0947-0.1025,0.2305-0.1748,0.4082-0.2148
						c0.2461-0.0566,0.4775-0.0107,0.6943,0.1387c0.2158,0.1484,0.3555,0.3564,0.416,0.6221
						C77.1406,123.9404,77.1289,124.2148,77.0469,124.5029z"/>
          <path fill="#231F20" d="M77.707,126.5107l-3.0225,2.3203l-0.0615-0.2715l1.0371-0.7949l-0.374-1.6387l-1.2793-0.2637
						l-0.0615-0.2734l3.7285,0.7803L77.707,126.5107z M75.8535,127.6162l1.4141-1.082l-1.7422-0.3594L75.8535,127.6162z"/>
          <path fill="#231F20" d="M78.1299,128.4756l0.1592,0.6992c0.084,0.3652,0.0703,0.6602-0.04,0.8848
						c-0.1104,0.2236-0.3018,0.3662-0.5713,0.4277c-0.3232,0.0742-0.6084-0.0293-0.8555-0.3115
						c0.0059,0.543-0.2188,0.8652-0.6729,0.9688c-0.2725,0.0615-0.5117,0.0107-0.7178-0.1553
						c-0.207-0.165-0.3506-0.4219-0.4297-0.7676l-0.2236-0.9805L78.1299,128.4756z M76.418,129.1387l-1.3643,0.3115l0.1582,0.6943
						c0.0654,0.2861,0.1768,0.4893,0.333,0.6104c0.1572,0.1201,0.3389,0.1582,0.5449,0.1104
						c0.458-0.1045,0.6113-0.4873,0.4609-1.1455L76.418,129.1387z M77.9727,128.7842l-1.3359,0.3047l0.082,0.3604
						c0.1396,0.6104,0.4316,0.8643,0.876,0.7627c0.4463-0.1025,0.5986-0.4609,0.458-1.0771L77.9727,128.7842z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M82.4121,120.3418l-0.2285,0.1836c-0.0488-0.3438-0.1396-0.5996-0.2734-0.7676
						c-0.1289-0.1621-0.2852-0.2559-0.4707-0.2871c-0.1846-0.0293-0.3496,0.0137-0.4941,0.1289
						c-0.1035,0.082-0.1719,0.1895-0.2041,0.3203c-0.0322,0.1289-0.0059,0.3281,0.0791,0.5918
						c0.0869,0.2676,0.1406,0.4668,0.1641,0.6016s0.0127,0.2734-0.0322,0.416c-0.0459,0.1426-0.1455,0.2773-0.3018,0.4004
						c-0.2061,0.1641-0.4404,0.2285-0.7031,0.1914c-0.2637-0.0391-0.4824-0.166-0.6562-0.3848
						c-0.1777-0.2227-0.2832-0.5156-0.3145-0.875l0.2441-0.1953c0.0176,0.4121,0.1006,0.7148,0.2539,0.9062
						c0.126,0.1582,0.2852,0.252,0.4766,0.2793c0.1904,0.0254,0.3604-0.0195,0.5107-0.1406
						c0.1143-0.0898,0.1904-0.2051,0.2275-0.3477c0.0381-0.1406,0.0137-0.3457-0.0723-0.6172s-0.1406-0.4707-0.1621-0.5996
						c-0.0234-0.1289-0.0137-0.2598,0.0273-0.3945c0.04-0.1328,0.1318-0.2578,0.2734-0.3711
						c0.1982-0.1562,0.4258-0.2168,0.6855-0.1758s0.4756,0.168,0.6455,0.3809C82.2539,119.7949,82.3623,120.0469,82.4121,120.3418z"
          />
          <path fill="#231F20" d="M84.5947,122.8008l0.165,0.209l-1.4658,1.1699c-0.4014,0.3184-0.7939,0.4609-1.1797,0.4258
						c-0.3838-0.0352-0.71-0.2188-0.9736-0.5508c-0.2646-0.3301-0.3711-0.6875-0.3223-1.0664
						c0.0479-0.3828,0.2598-0.7227,0.6338-1.0215l1.5146-1.207l0.167,0.2109l-1.5068,1.2012
						c-0.3203,0.2559-0.5039,0.541-0.5488,0.8535c-0.0449,0.3145,0.0391,0.6074,0.2539,0.877
						c0.2168,0.2715,0.4844,0.418,0.8027,0.4434s0.6465-0.0977,0.9824-0.3652L84.5947,122.8008z"/>
          <path fill="#231F20" d="M87.1367,125.9902l-2.6875,2.1426l-0.1357-0.1699l0.7188-3.918l-2.3486,1.873l-0.166-0.207
						l2.6875-2.1426l0.1406,0.1758l-0.7227,3.9121l2.3486-1.873L87.1367,125.9902z"/>
        </g>
      </g>
      <g>
        <g>
          <path fill="#231F20" d="M83.5664,113.5l1.084,0.5225c0.5488,0.2637,0.8975,0.6094,1.0469,1.0371
						c0.1514,0.4277,0.1152,0.8691-0.1035,1.3262c-0.2168,0.4482-0.5371,0.748-0.9648,0.9033
						c-0.4258,0.1533-0.9023,0.1045-1.4297-0.1494l-1.125-0.542L83.5664,113.5z M83.709,113.8145l-1.2988,2.6982l0.873,0.4209
						c0.4004,0.1934,0.793,0.2314,1.1797,0.1133c0.3848-0.1182,0.6758-0.3799,0.8711-0.7861
						c0.1914-0.3975,0.2148-0.7852,0.0723-1.1641c-0.1406-0.3779-0.4219-0.667-0.8398-0.8682L83.709,113.8145z"/>
          <path fill="#231F20" d="M88.4541,115.8047c0.458,0.2207,0.7725,0.5625,0.9424,1.0234
						c0.1699,0.4619,0.1484,0.9141-0.0654,1.3574c-0.2129,0.4424-0.5527,0.7402-1.0205,0.8955
						c-0.4668,0.1543-0.9287,0.1221-1.3867-0.0986c-0.457-0.2197-0.7695-0.5605-0.9375-1.0215
						c-0.1699-0.4609-0.1475-0.9121,0.0654-1.3545c0.2139-0.4434,0.5527-0.7432,1.0186-0.8984
						C87.5352,115.5527,87.9971,115.585,88.4541,115.8047z M87.0391,118.7646c0.3848,0.1855,0.7754,0.2109,1.168,0.0742
						c0.3926-0.1357,0.6797-0.3955,0.8643-0.7783c0.1846-0.3838,0.21-0.7715,0.0713-1.1641
						c-0.1387-0.3916-0.4004-0.6807-0.7871-0.8662c-0.3867-0.1865-0.7783-0.2119-1.1738-0.0781
						c-0.3965,0.1357-0.6855,0.3955-0.8701,0.7793c-0.1846,0.3828-0.2061,0.7705-0.0654,1.1641
						C86.3877,118.2881,86.6523,118.5781,87.0391,118.7646z"/>
          <path fill="#231F20" d="M91.3867,119.0381l1.8691-0.8711l0.2441,0.1162l-1.4922,3.0977l-0.2422-0.1162l1.3223-2.748
						l-1.875,0.8809l-0.4863-2.0176l-1.3223,2.7471l-0.2402-0.1152l1.4922-3.0977l0.2402,0.1152L91.3867,119.0381z"/>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
export default {
  name: 'sdCalendar',
  props: ['data'],
  computed: {
    calendar() {
      if (this.data.calendar) return this.data.calendar;
    },
  },
  mounted() {
    this.$emit('initialize-component', { component: this.calendar, element: this.$el });
  },
};
</script>

<style lang="scss" scoped>
  //.calendar__day-disc,
  //.calendar__weekday-disc {
  //  transition: transform 120ms cubic-bezier(0.93, 0.01, 0.58, 1);
  //}
</style>
